mutation RemoveReportingLabel($computedDeliverableIdentifier: InputComputedDeliverableIdentifier!, $campaignId: ID!) {
    removeComputedDeliverableCustomReportingLabel(
        computedDeliverableIdentifier: $computedDeliverableIdentifier
        campaignId: $campaignId
    ) {
        _id
        reportingLabel
        hash
    }
}
